import { get as getCookie } from "browser-cookies";

import { Config } from "./config";

const configKey = "config";

const defaultConfig: Config = {
    AppInsightsConnectionString: "",
    InstrumentationKey: "",
    ApplicationName: "",
    EnvironmentName: "",
    CustomerPortal: "",
    EmployeePortal: ""
};

export const getConfig = (): Config => {
    const configCookie = getCookie(configKey);
    if (configCookie) {
        localStorage.setItem(configKey, configCookie);
    }

    const configJson = configCookie ?? localStorage.getItem(configKey);
    return configJson ? JSON.parse(configJson) as Config : defaultConfig;
};
